import React from 'react';

import CloseIcon from 'images/icon/close.inline.svg';
import ModalQRcodeDesktopImgEvent from 'images/modal_qr_desktop_event.png';
import ModalQRcodeDesktopImg from 'images/modal_qr_desktop_member.png';

import ImgBox from 'components/atoms/ImgBox';

import styles from './index.module.css';

interface MemberJoinModalDesktopProperty {
	isEvent?: boolean;
	onCloseClick: () => void;
}

const MemberJoinModalDesktop: React.FC<MemberJoinModalDesktopProperty> = ({
	isEvent = false,
	onCloseClick = () => {},
}) => (
	<div className={styles.modalMask}>
		<ImgBox
			backgroundImgUrl={isEvent ? ModalQRcodeDesktopImgEvent : ModalQRcodeDesktopImg}
			className={styles.modalDesktop}
		>
			<div
				className={styles.closeIconBox}
				role="button"
				tabIndex={0}
				onKeyPress={() => {}}
				onClick={onCloseClick}
			>
				<CloseIcon />
			</div>
		</ImgBox>
	</div>
);

export default MemberJoinModalDesktop;
